define('Stock.Status.Shopping.EntryPoint', [
    'Stock.Status',
    'Cart.Summary.View.Stock.Status',
    'Cart.Detailed.View.Stock.Status'
], function StockStatusShoppingEntryPoint(
    StockStatus
) {
    'use strict';

    return {
        mountToApp: function mountToApp(container) {
            StockStatus.mountToApp(container);
        }
    };
});

